var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{class:_vm.inputClass,attrs:{"value":_vm.display,"disabled":_vm.disabled,"label":_vm.label,"outline":_vm.outline,"placeholder":"DD/MM/YYYY","maxlength":"10","inputmode":"numeric","hide-details":"","rounded":"","clearable":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }